import styled from "styled-components";

export const ChartContainer = styled.div`
	background-color: ${(props) => props.theme.colours.light_0};

	border-radius: 6px;
	margin: 12px;
	padding: 6px;
`;
